var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.total > 0
      ? _c(
          "div",
          { staticClass: "middle" },
          [
            _c("el-pagination", {
              attrs: {
                layout: "prev, pager, next",
                total: _vm.total,
                "page-size": _vm.tamanhoPagina,
                "current-page": _vm.pagina
              },
              on: { "current-change": _vm.alterarPagina }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.showTotalListagem
      ? _c("div", { staticClass: "contador-total" }, [
          _c("span", [_vm._v("Total de registros: " + _vm._s(_vm.total))])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e2586cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e2586cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPaginacao.vue
// module id = null
// module chunks = 